import "./FeaturesPage.css";

function FeaturesPage() {
  return (
    <div className="features-page">
      <main className="features-content">
        <h1>Features</h1>

        <section className="feature-section">
          <h2>✨ Latest Features</h2>
          <ul>
            <li>
              <span className="new-badge">NEW</span>{" "}
              <strong>Mandatory Segue Ordering</strong>
              <p>
                When patterns such as Mike&apos;s Song → I Am Hydrogen →
                Weekapaug Groove are detected, the generator reconstructs the
                entire chain in historical order. Continuation songs are
                injected immediately after the trigger song, and duplicates are
                skipped. This keeps sandwiches intact even when initial output
                is shuffled.
              </p>
            </li>
            <li>
              <span className="new-badge">NEW</span>{" "}
              <strong>Same-Show Segue Parameter</strong>
              <p>
                Enabling <code>same_show_segues</code> (on by default) pulls the
                actual track IDs from the same historical performance. If
                Mike&apos;s Song from Show X contained the full Mike&apos;s &gt;
                Hydrogen &gt; Weekapaug sandwich, those exact tracks from Show X
                are used so the original jams and transitions stay intact
                instead of mixing recordings from different nights.
              </p>
            </li>
            <li>
              <span className="new-badge">NEW</span>{" "}
              <strong>Lottery Ticket Segues</strong>
              <p>
                Lottery tickets are rare, historically unusual segue chains
                (like Chalk Dust Torture → You Sexy Thing → Mercury) that appear
                randomly during generation with probability scaled to the
                jamminess dial (0% at jamminess=0.0, up to 10% at
                jamminess=1.0). When triggered, the system uses a coin-flip
                mechanism for each continuation track, creating exponentially
                decreasing probability for longer chains, and compensates for
                added duration by removing lowest-liked songs if the set exceeds
                the 15% over-target threshold, ensuring sets stay within the
                tolerance range.
              </p>
            </li>
          </ul>
        </section>

        <section className="feature-section">
          <h2>🚀 User Experience Enhancements</h2>
          <ul>
            <li>
              <strong>Modernized UI w/ React</strong> - Enjoy a sleeker, faster,
              and more responsive experience.
            </li>
            <li>
              <strong>Dark/Light Mode overhaul</strong> - Choose your theme or
              default to whatever your system is set to.
            </li>
            <li>
              <strong>Persistent Audio Player</strong> - Continues playing as
              you navigate between pages
            </li>
            <li>
              <strong>Setlist Memory</strong> - Your generated shows are saved
              locally and persist across sessions
            </li>
            <li>
              <strong>Playback Resume</strong> - Audio remembers your position
              even after page refresh
            </li>
            <li>
              <strong>Interactive Track Tooltips</strong> - Click any song to
              see performance details from Phish.in
            </li>
            <li>
              <strong>Mobile-Optimized UI</strong> - Fully responsive design
              with touch-friendly tooltips
            </li>
            <li>
              <strong>Phish.in Show Links</strong> - Direct links to full shows
              from tooltips
            </li>
          </ul>
        </section>

        <section className="feature-section">
          <h2>🎯 Core Features</h2>
          <ul>
            <li>
              <strong>ML-Enhanced Generation</strong> - Historical placement
              probabilities and transition patterns
            </li>
            <li>
              <strong>Weighted Set Closers</strong> - Songs selected based on
              historical ending probability
            </li>
            <li>
              <strong>Authentic Track Versions</strong> - Actual set-ending
              recordings from Phish.in
            </li>
            <li>
              <strong>Smart Frequency Caps</strong> - Prevents rare songs from
              appearing too often
            </li>
            <li>
              <strong>Era-Aware Selection</strong> - Filter by 1.0, 2.0, 3.0, or
              4.0 eras
            </li>
            <li>
              <strong>40+ Years of Data</strong> - Powered by comprehensive
              Phish.in archive
            </li>
            <li>
              <strong>Jamminess Control</strong> - Dial up or down jam intensity
              (0.0 = tight, 1.0 = extended jams)
            </li>
            <li>
              <strong>Dynamic Set Lengths</strong> - Realistic duration based on
              jam intensity
            </li>
          </ul>
        </section>

        <section className="feature-section">
          <h2>⚠️ Known Issues</h2>
          <ul className="issues-list">
            <li>
              <strong>Crossfade Feature (⚡️):</strong> Browser audio APIs
              aren't quite ready for seamless track transitions yet. The code is
              there, just waiting for the tech to catch up. In the meantime,
              think of the brief silence between songs as part of the authentic
              tape-listening experience.
            </li>
            <li>UI Bugs w/ new front end. Report them if you see them!</li>
            <li>Song progression sometimes only works on /setlist view.</li>
            <li>Opener selection can be improved</li>
            <li>Short songs appear overweighted as set closers</li>
            <li>
              Jamminess control is experimental – results may vary wildly!
            </li>
          </ul>
        </section>

        <section className="feature-section">
          <h2>📊 Data Attribution</h2>
          <p>
            All Phish show and setlist data is sourced from{" "}
            <a
              href="https://phish.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Phish.in
            </a>
            , a comprehensive archive of Phish recordings and setlists. This
            project would not be possible without their incredible work
            maintaining this community resource.
          </p>
        </section>
      </main>
    </div>
  );
}

export default FeaturesPage;
